import IResult from "../../models/result/IResult";
import { sendGet } from "./generic";

export const getCallRecording = (applicationId: string, sessionId: string, processed: boolean): Promise<IResult<any>> => {
    return sendGet(`/CallRecording/${applicationId}/${sessionId}?NoiseCancelledAudio=${processed}`);
}